import { useMutation } from '@tanstack/react-query'
import useCycleApi from 'common/hooks/useCycleApi'

import { GROWTH_REQUEST_CONFIG } from '.'
import { CreateGrowthVariables, EditGrowthVariables } from './types'

export const useMutateCreateGrowthShrimp = () => {
  const cycleApi = useCycleApi()
  return useMutation(({ body: data }: CreateGrowthVariables) =>
    cycleApi.request({ ...GROWTH_REQUEST_CONFIG.createGrowth, data })
  )
}

export const useMutatePatchGrowthShrimp = () => {
  const cycleApi = useCycleApi()
  return useMutation(({ growthId, body: data }: EditGrowthVariables) =>
    cycleApi.request({
      ...GROWTH_REQUEST_CONFIG.editGrowth,
      url: `${GROWTH_REQUEST_CONFIG.editGrowth.url}/${growthId}`,
      data,
    })
  )
}

export const useMutateDeleteGrowthShrimp = () => {
  const cycleApi = useCycleApi()
  return useMutation((growthId: number) =>
    cycleApi.request({
      ...GROWTH_REQUEST_CONFIG.deleteGrowth,
      url: `${GROWTH_REQUEST_CONFIG.deleteGrowth.url}/${growthId}`,
    })
  )
}
